import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

export default class StringTokenModel extends JsonApiObject {
    static async post(id: string, value: string, description: string | null = null) {
        let query = {
            body: {
                data: {
                    type: 'stringToken',
                    attributes: {
                        value,
                        description,
                    },
                    relationships: {
                        string: {
                            data: {
                                type: 'string',
                                id,
                            },
                        },
                    },
                },
            },
        }

        let res = await Vue.prototype.$vbit.post('language', `stringTokens`, query)

        return res.data ? new StringTokenModel(res.data, res.included) : res
    }

    static async get(stringTokenId: string) {
        let query = {}

        let res = await Vue.prototype.$vbit.get('language', `stringTokens/${stringTokenId}`, query)

        return res.data ? new StringTokenModel(res.data, res.included) : res
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    value
    description
    createdAt
    updatedAt

    get string() {
        return this._relationships['string'] ? this._relationships['string'] : null
    }

    async patch(value: string, description: string | null = null) {
        let query = {
            updatedAt: this['updatedAt'],
            body: {
                data: {
                    type: 'stringToken',
                    id: this._id,
                    attributes: {
                        value,
                        description,
                    },
                },
            },
        }

        let res = await Vue.prototype.$vbit.patch('language', `stringTokens/${this._id}`, query)

        return res.data ? this.initalize(res.data, res.included) : res
    }

    async delete() {
        let query = {
            updatedAt: this['updatedAt'],
        }

        return await Vue.prototype.$vbit.delete('language', `stringTokens/${this._id}`, query)
    }
}
